import { computed } from "vue";
import axios from "axios";

// AXIOS API
axios.defaults.baseURL =
    window.location.host === "e-chat.tech"
        ? "https://e-chat.tech/profile"
        : "https://dev.e-chat.tech/profile";
// "https://e-chat.tech/profile"

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
    failedQueue.forEach(prom => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    });
    failedQueue = [];
};

/**
 * Генерирует пользовательский экземпляр API с заголовками для выполнения HTTP-запросов.
 *
 * @return {object} Объект (HEADERS и AXIOS API)
 */
export default function useApi() {
    // HEADERS
    const apiHeader = computed(() => ({
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage?.getItem("token")}`,
    }));

    async function refreshToken() {
        try {
            const response = await axios.post(
                "api/refresh",
                {},
                {
                    headers: apiHeader.value,
                }
            );
            const refreshedToken = response.data.data.access_token;
            localStorage.setItem("token", refreshedToken);
            return refreshedToken;
        } catch (error) {
            localStorage.removeItem("token");
            window.location.assign("/profile/login");
            throw error;
        }
    }

    const instance = axios.create({});

    instance.interceptors.response.use(
        (response) => response,
        async (error) => {
            const { response } = error;
            const originalRequest = error.config;

            if (response && response.status === 401 && !location.pathname.includes("login")) {
                if (isRefreshing) {
                    return new Promise((resolve, reject) => {
                        failedQueue.push({ resolve, reject });
                    })
                        .then(token => {
                            originalRequest.headers["Authorization"] = `Bearer ${token}`;
                            return instance(originalRequest);
                        })
                        .catch(err => {
                            return Promise.reject(err);
                        });
                }

                originalRequest._retry = true;
                isRefreshing = true;

                try {
                    const refToken = await refreshToken();
                    if (refToken) {
                        originalRequest.headers["Authorization"] = `Bearer ${refToken}`;
                        processQueue(null, refToken);
                        return instance(originalRequest);
                    }
                } catch (refreshError) {
                    processQueue(refreshError, null);
                    return Promise.reject(refreshError);
                } finally {
                    isRefreshing = false;
                }
            }
            return Promise.reject(error);
        }
    );
    return {
        headers: apiHeader.value,
        reactiveHeaders: apiHeader,
        api: instance,
    };
}
